import { AccountType, DestinationAccountResponse } from "../class/destinationAccount";
import { SkippableBoolean, SourceAccountResponse } from "../class/sourceAccount";
import { TransferResponse, TransferStatusTypes } from "../class/transferDetails";
import { TransferAccountType, TransferIntentResponse } from "../class/transferIntent";
import { UserDetailsResponse } from "../class/userDetails";
import { StaticDataList } from "./APIConfirmTransfer";
import { FetchEmployerListResponse } from "./APIEmployer";

export const userDetailsRes: UserDetailsResponse = {
  firstName: "Katie",
  middleName: "",
  lastName: "Clark",
  suffix: "",
  citizenship: "",
  dateOfBirth: "",
  ssnOrTin: "",
  maritalStatus: "",
  spouseEmail: "",
  spouseName: "",
  spousePhoneNumber: "",
  spouseDateOfBirth: "",
  signatureFileName: "",
  userIdentityId: 123,
  userOnboarded: false,
  address: {
    addressLine1: "123 Chicago Lane",
    addressLine2: "",
    city: "Chicago",
    state: "Illinois",
    zipCode: "12345",
  },
};

export const citizenshipResponse: StaticDataList = [
  "United States",
  "United Kingdom",
  "Mexico",
  "India",
  "China",
  "Philippines",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua And Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Ashmore And Cartier Islands",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia And Herzegovina",
  "Botswana",
  "Brazil",
  "British Virgin Islands",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burma",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Democratic Republic Of The Congo",
  "Republic Of The Congo",
  "Coral Sea Islands",
  "Costa Rica",
  "Cote D'Ivoire",
  "Croatia",
  "Cuba",
  "Curacao",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Polynesia",
  "French Southern And Antarctic Lands",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Vatican City",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Isle Of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "North Korea",
  "South Korea",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Federated States Of Micronesia",
  "Midway Islands",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Namibia",
  "Nepal",
  "Netherlands",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norfolk Island",
  "North Macedonia",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Pitcairn Islands",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Saint Barthelemy",
  "Saint Helena, Ascension, And Tristan Da Cunha",
  "Saint Kitts And Nevis",
  "Saint Lucia",
  "Saint Martin",
  "Saint Pierre And Miquelon",
  "Saint Vincent And The Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome And Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Svalbard",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad And Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks And Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands",
  "Wake Island",
  "Wallis And Futuna",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const stateResponse: StaticDataList = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
  "District of Columbia",
];

export const suffixResponse: StaticDataList = ["Jr.", "Sr.", "2nd", "3rd", "II", "III", "IV", "V", "VI"];

export const mockSourceAccountRes: SourceAccountResponse = {
  aggregatorLink: null,
  aggregatorPublicToken: null,
  aggregatorSkipped: "UNKNOWN",
  planSponsor: "University of Chicago",
  providerName: null,
  providerSkipped: "UNKNOWN" as SkippableBoolean,
  salaryRange: null,
  sourceAccountId: 123,
  sourceStatementFileNames: [],
  startYear: null,
  statementSkipped: "UNKNOWN" as SkippableBoolean,
  terminatedYear: null,
  transferId: 456,
};

export const sampleIncompleteSourceAccountRes: SourceAccountResponse = {
  aggregatorLink: null,
  aggregatorPublicToken: null,
  aggregatorSkipped: "UNKNOWN",
  planSponsor: "University of Chicago",
  providerName: "TIAA",
  providerSkipped: "UNKNOWN",
  salaryRange: null,
  sourceAccountId: 14116,
  sourceStatementFileNames: [],
  startYear: "",
  statementSkipped: "UNKNOWN",
  terminatedYear: "",
  transferId: 21612,
};

export const sampleCompleteSourceAccountRes: SourceAccountResponse = {
  ...sampleIncompleteSourceAccountRes,
  startYear: "2000",
  terminatedYear: "2002",
  transferId: 21612,
  statementSkipped: "TRUE",
};

export const mockDestinationResponse: DestinationAccountResponse = {
  destinationStatementFileNames: [],
  transferId: 123,
  destinationAccountId: 456,
  providerName: "InvestCo",
  planName: "InvestCo Retirement Plan",
  planNumber: "4988",
  traditionalIraAccountNumber: "123",
  rothIraAccountNumber: "123",
  destinationAccountType: AccountType.employerSponsored,
  planSponsor: "someplan",
};

export const completeDestinationAccountResponse: DestinationAccountResponse = {
  destinationStatementFileNames: [],
  transferId: 123,
  destinationAccountId: 456,
  providerName: "InvestCo",
  planName: "InvestCo Retirement Plan",
  planNumber: "4988",
  traditionalIraAccountNumber: "123",
  rothIraAccountNumber: "123",
  destinationAccountType: AccountType.employerSponsored,
  planSponsor: "someplan",
};

export const emptyTransferResponse: TransferResponse = {
  destinationAccount: mockDestinationResponse,
  sourceAccounts: [],
  transferId: 123,
  transferStatus: TransferStatusTypes.inProgress,
  userId: "123",
  userIdentityId: 123,
  transferIntentReference: "123",
};

export const mockTransferInitiateResponse: TransferResponse = {
  transferId: 1001,
  transferStatus: TransferStatusTypes.initiatedAtProvider,
  destinationAccount: mockDestinationResponse,
  sourceAccounts: [mockSourceAccountRes],
  userId: "123",
  userIdentityId: 123,
  transferIntentReference: "123",
};

export const mockEmployerSearchResponse: FetchEmployerListResponse = [
  {
    employerId: "20231013190020NAL0069101154001",
    employerName: "United Natural Foods, Inc",
    employerCity: "Providence",
    employerState: "RI",
    numberOfParticipants: 49146.0,
  },
  {
    employerId: "20231016102332NAL0024519603001",
    employerName: "Trustees Of The University Of Pa",
    employerCity: "Philadelphia",
    employerState: "PA",
    numberOfParticipants: 28067.0,
  },
  {
    employerId: "20230922134210NAL0003098227001",
    employerName: "New York University",
    employerCity: "New York",
    employerState: "NY",
    numberOfParticipants: 22292.0,
  },
  {
    employerId: "20231013134222NAL0021964227001",
    employerName: "Georgetown University",
    employerCity: "Washington",
    employerState: "DC",
    numberOfParticipants: 19371.0,
  },
  {
    employerId: "20231016163914NAL0039058161001",
    employerName: "Board Of Trustees Of The Amalgamated Transit Union",
    employerCity: "Springfield",
    employerState: "IL",
    numberOfParticipants: 17714.0,
  },
  {
    employerId: "20231010122249NAL0028144193001",
    employerName: "Princeton University",
    employerCity: "Princeton",
    employerState: "NJ",
    numberOfParticipants: 16801.0,
  },
  {
    employerId: "20231013124610NAL0044441088002",
    employerName: "Trustees Of Boston University",
    employerCity: "Boston",
    employerState: "MA",
    numberOfParticipants: 16186.0,
  },
  {
    employerId: "20230718140512NAL0000903969001",
    employerName: "University Of Notre Dame Du Lac",
    employerCity: "Notre Dame",
    employerState: "IN",
    numberOfParticipants: 14179.0,
  },
  {
    employerId: "20231016103753NAL0038067169001",
    employerName: "Unifirst Corporation",
    employerCity: "Wilmington",
    employerState: "MA",
    numberOfParticipants: 12882.0,
  },
  {
    employerId: "20231016152507NAL0025241635001",
    employerName: "Trustees Of National Production Workers Union Severance Trust Fund",
    employerCity: "Downers Grove",
    employerState: "IL",
    numberOfParticipants: 10358.0,
  },
];

export const mockProviderResponse = ["TIAA"];

export const randomScenario = () => Math.floor(Math.random() * 2);

export const sampleTransferIntentInResponseIra: TransferIntentResponse = {
  transferIntentReference: "79f1f71f-61b8-4af5-a808-5dd81aef9086",
  status: "INPROGRESS",
  created: "2024-10-02",
  destinationAccounts: [
    {
      type: TransferAccountType.IRA,
      accountNumber: "19237-AZ",
      providerName: "InvestCo",
      acceptsRothFunds: true,
      isPrimary: true,
    },
  ],
  sourceAccounts: [
    // {
    //   planSponsor: "University of Chicago",
    //   providerName: "TIAA",
    //   planName: "UOC 403b",
    //   hasRothFunds: false,
    //   type: TransferAccountType.EMPLOYER_401k,
    // },
  ],
  // mode: "TRANSFER_IN",
  // transferAccount: {
  //   accountNumber: "3989",
  //   accountType: TransferAccountType.IRA,
  //   planName: "",
  //   planNumber: "",
  //   acceptsRothFunds: AcceptsRothFundsResponse.YES,
  //   created: "2024-06-25T14:15:22Z",
  //   providerName: "InvestCo",
  // },
  // accounts: [
  //   {
  //     accountNumber: "Roth_12345",
  //     accountType: TransferAccountType.ROTH_IRA,
  //     created: "2024-06-25T14:15:22Z",
  //     providerName: "InvestCo",
  //   },
  // ],
  userIdentity: {
    email: "jamie-lee@manifest-transfer.com",
    phoneNumber: "+13124445566",
    userDetails: {
      clientUserId: "",
      created: "",
      userId: "",
      suffix: "",
      email: "jamie-lee@manifest-transfer.com",
      phoneNumber: "+13124445566",
      firstName: "Jamie",
      middleName: "Lee",
      lastName: "Smith",
      citizenship: "",
      dateOfBirth: "",
      married: undefined,
      address: undefined,
    },
  },
};

export const sampleTransferIntentOutResponseIra: TransferIntentResponse = {
  transferIntentReference: "79f1f71f-61b8-4af5-a808-5dd81aef9081",
  status: "INPROGRESS",
  created: "2024-10-02",
  destinationAccounts: [
    {
      type: TransferAccountType.IRA,
      accountNumber: "102020",
      providerName: "InvestCo",
      acceptsRothFunds: false,
      isPrimary: false,
    },
  ],
  sourceAccounts: [
    {
      type: TransferAccountType.EMPLOYER_401k,
      planSponsor: "ABC Corp",
      planName: "Supplemental Retirement Plan",
      planNumber: "001",
      hasRothFunds: false,
      providerName: "TIAA",
    },
  ],
  // mode: "TRANSFER_OUT",
  // transferAccount: {
  //   accountNumber: "3989",
  //   accountType: TransferAccountType.EMPLOYER_401k,
  //   planSponsor: "ABC Corp",
  //   planName: "Supplemental Retirement Plan",
  //   planNumber: "001",
  //   acceptsRothFunds: AcceptsRothFundsResponse.YES,
  //   created: "2024-06-25T14:15:22Z",
  //   providerName: "TIAA",
  // },
  // accounts: [

  //   },
  // ],
  userIdentity: {
    email: "jamie-lee@manifest-transfer.com",
    phoneNumber: "+13124445566",
    userDetails: {
      clientUserId: "",
      created: "",
      userId: "",
      suffix: "",
      email: "jamie-lee@manifest-transfer.com",
      phoneNumber: "+13124445566",
      firstName: "Jamie",
      middleName: "Lee",
      lastName: "Smith",
      citizenship: "",
      dateOfBirth: "",
      married: undefined,
      address: undefined,
    },
  },
};
export const sampleTransferIntentOutResponseIra2: TransferIntentResponse = {
  transferIntentReference: "79f1f71f-61b8-4af5-a808-5dd81aef9081",
  status: "INPROGRESS",
  created: "2024-10-02",
  destinationAccounts: [],
  sourceAccounts: [
    {
      type: TransferAccountType.EMPLOYER_401k,
      planSponsor: "ABC Corp",
      planName: "Supplemental Retirement Plan",
      planNumber: "001",
      hasRothFunds: false,
      providerName: "TIAA",
    },
  ],
  userIdentity: {
    email: "jamie-lee@manifest-transfer.com",
    phoneNumber: "+13124445566",
    userDetails: {
      clientUserId: "",
      created: "",
      userId: "",
      suffix: "",
      email: "jamie-lee@manifest-transfer.com",
      phoneNumber: "+13124445566",
      firstName: "Jamie",
      middleName: "Lee",
      lastName: "Smith",
      citizenship: "",
      dateOfBirth: "",
      married: undefined,
      address: undefined,
    },
  },
};

export const sampleTransferIntentInResponseEmployerSponsored: TransferIntentResponse = {
  transferIntentReference: "79f1f71f-61b8-4af5-a808-5dd81aef9086",
  status: "INPROGRESS",
  created: "2024-10-02",
  destinationAccounts: [
    {
      type: TransferAccountType.EMPLOYER_403b,
      providerName: "InvestCo",
      planSponsor: "The University of Chicago",
      planName: "UOC 403b Plan",
      planNumber: "3989",
      acceptsRothFunds: true,
      isPrimary: true,
    },
  ],
  sourceAccounts: [],
  // transferAccount: {
  //   accountType: TransferAccountType.EMPLOYER_403b,
  //   planName: "UOC 401(k) Plan",
  //   planNumber: "3989",
  //   acceptsRothFunds: AcceptsRothFundsResponse.YES,
  //   created: "2024-06-25T14:15:22Z",
  //   providerName: "InvestCo",
  //   planSponsor: "The University of Chicago",
  // },
  // accounts: [
  //   {
  //     accountNumber: "Roth_12345",
  //     accountType: TransferAccountType.ROTH_IRA,
  //     created: "2024-06-25T14:15:22Z",
  //     providerName: "InvestCo",
  //   },
  //   {
  //     accountNumber: "IRA_3989",
  //     accountType: TransferAccountType.IRA,
  //     created: "2024-06-25T14:15:22Z",
  //     providerName: "InvestCo",
  //   },
  // ],
  userIdentity: {
    email: "jamie-lee@manifest-transfer.com",
    phoneNumber: "+13124445566",
    userDetails: {
      created: "",
      userId: "",
      suffix: "",
      clientUserId: "",
      email: "jamie-lee@manifest-transfer.com",
      phoneNumber: "+13124445566",
      firstName: "Jamie",
      middleName: "Lee",
      lastName: "Smith",
      citizenship: "",
      dateOfBirth: "",
      married: undefined,
      address: undefined,
    },
  },
};
export const sampleTransferResponse: TransferResponse = {
  destinationAccount: mockDestinationResponse,
  sourceAccounts: [mockSourceAccountRes],
  transferId: 10000,
  transferStatus: TransferStatusTypes.inProgress,
  userIdentityId: 12000,
  transferIntentReference: "transfer-intent",
  userId: "userid",
};

export const sampleTransferOutIntentResponse = {
  ...sampleTransferIntentInResponseIra,
  mode: "TRANSFER_OUT",
};

export const sampleInitiatedTransferResponse: TransferResponse = {
  destinationAccount: mockDestinationResponse,
  sourceAccounts: [mockSourceAccountRes],
  transferId: 10000,
  transferStatus: TransferStatusTypes.initiated,
  userIdentityId: 12000,
  transferIntentReference: "sample-transfer-intent",
  userId: "sample-user-reference",
};

type CreateTransferIntentData = {
  mode: string;
  transferAccount: {
    accountType: TransferAccountType;
    acceptsRothFunds: boolean;
    providerName: string;
  };
  accounts: any[];
  user: {
    clientUserId: string;
    email: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
  };
};

export const minimumCreateTransferIntentResponseIRA: CreateTransferIntentData = {
  mode: "TRANSFER_IN",
  transferAccount: {
    accountType: TransferAccountType.IRA,
    acceptsRothFunds: true,
    providerName: "Mariner Financial",
  },
  accounts: [],
  user: {
    clientUserId: "client-user-id",
    email: "user-email@email.com",
    phoneNumber: "",
    firstName: "Jamie",
    lastName: "Smith",
  },
};

export const minimumTransferIntentResponseIRA: TransferIntentResponse = {
  transferIntentReference: "sample-transfer-intent",
  status: "PENDING",
  created: "2024-10-02",
  destinationAccounts: [],
  sourceAccounts: [],
  userIdentity: {
    email: "user-email@email.com",
    phoneNumber: "",
    userDetails: {
      created: "2024-10-02",
      clientUserId: "client-user-id",
      email: "user-email@email.com",
      phoneNumber: "",
      firstName: "Jamie",
      lastName: "Smith",
    },
  },
};

export const minimumTransferIntentResponseEmployer: TransferIntentResponse = {
  transferIntentReference: "sample-transfer-intent",
  status: "PENDING",
  created: "2024-10-02",
  destinationAccounts: [],
  sourceAccounts: [],

  // transferAccount: {
  //   accountType: TransferAccountType.EMPLOYER_457,
  //   acceptsRothFunds: AcceptsRothFundsResponse.YES,
  //   providerName: "Mariner Financial",
  // },
  // accounts: [],
  userIdentity: {
    email: "user-email@email.com",
    phoneNumber: "",
    userDetails: {
      created: "2024-10-02",
      clientUserId: "client-user-id",
      email: "user-email@email.com",
      phoneNumber: "",
      firstName: "Jamie",
      lastName: "Smith",
    },
  },
};

export const generateSampleTransferOutIntentResponse = (): TransferIntentResponse => {
  return randomScenario() === 0 ? sampleTransferIntentOutResponseIra : sampleTransferIntentOutResponseIra2;
};

export const generateSampleTransferInIntentResponse = (): TransferIntentResponse => {
  return sampleTransferIntentInResponseEmployerSponsored;
};

export const generateSamplePartialTransfer = (): TransferIntentResponse => {
  return {
    subClient: {
      name: "Pacific Life Insurance",
    },
    destinationAccounts: [
      {
        type: TransferAccountType.ANNUITY,
        acceptsRothFunds: true,
        accountNumber: "123817263",
        isPrimary: true,
        providerName: "Pacific Life",
      },
    ],
    transferIntentReference: "1378172389123",
    status: "PENDING",
    created: "123891723",
    sourceAccounts: [
      {
        type: TransferAccountType.EMPLOYER_401k,
        hasRothFunds: true,
        planName: "Company 401k plan name",

        planSponsor: "Test Company",
        providerName: "The Vanguard Group",
        partialTransfer: {
          transferType: "AMOUNT",
          preTax: 1000.0,
          afterTax: 1000.0,
          roth: 1000.0,
        },
      },
    ],
    userIdentity: {
      email: "irene@usemanifest.com",
      phoneNumber: "+12174727272",
      userDetails: {
        email: "irene@usemanifest.com",
        clientUserId: "123",
        firstName: "Irene",
        lastName: "Chow",
      },
    },
    version: "2",
  };
};
